import moment from 'moment';

import accountUsageOne from '../../accountUsageOne';
import accountUsageThree from '../../accountUsageThree';
import accountUsageTwo from '../../accountUsageTwo';
import additionalDocuments from '../../additionalDocuments';
import companyAddresses from '../../companyAddresses';
import companyInfo from '../../companyInfo';
import companySector from '../../companySector';
import personsBasic from '../../personsBasic';
import personsDetails from '../../personsDetails';
import personsSettings from '../../personsSettings';
import submit from '../../submit';
import userInfo from '../../userInfo';

export const today = () => moment.utc().toDate();

export const wizardStepRoutes = [
    userInfo,
    companyInfo,
    companyAddresses,
    companySector,
    accountUsageOne,
    accountUsageTwo,
    accountUsageThree,
    personsBasic,
    personsSettings,
    personsDetails,
    additionalDocuments,
    submit,
];

export const helpRoutes = [personsSettings, personsDetails];
